import React from 'react';
import { Box } from '@mui/material';
import CircularProgress from '@mui/material/CircularProgress';
import Posts from '../components/Posts/Posts';
import styles from './PostsPage.module.scss';
import usePostNavigation from '../hooks/useHookpost';
import useFetchHook from '../hooks/useFecthHook';
import { useTranslation } from "react-i18next";
import data from './data/data.json'

interface PostInterface {
    id: number;
    title: string;
    date: string;
    abstract: string;
    content: string;
}

interface Imageurl {
    message: string;
    status: string;
}

export default function PostsPages() {
    const { openPostPage } = usePostNavigation();
 
   const examplePosts: PostInterface[] = data as PostInterface[];
   

    const { data: imageData, loading: imageLoading, error: imageError } = useFetchHook<Imageurl>('https://dog.ceo/api/breeds/image/random');


    if (imageLoading) {
        return (
            <Box
                display="flex"
                justifyContent="center"
                alignItems="center"
                height="100vh"
                width="100vw"
                position="absolute"
                top={0}
                left={0}
                zIndex={999}
            >
                <CircularProgress />
            </Box>
        );
    }


    return (
        <div className={styles.container}>
            {examplePosts.map((post) => (
                <div 
                    key={post.id}
                    className={styles.link}
                    onClick={() => openPostPage(post)} 
                >
                    <Posts
                        title={post.title}
                        date={post.date}
                        abstract={post.abstract}
                        content={post.content}
                        url={imageData?.message || ''} 
                    />
                </div>
            ))}
        </div>
    );
}
